let setGlobalLoader = null;

export const registerLoaderSetter = (setterFn) => {
  setGlobalLoader = setterFn;
};

export const showGlobalLoader = () => setGlobalLoader?.(true);
export const hideGlobalLoader = () => setGlobalLoader?.(false);